import { PermissionsEnum } from './permission.enum';

export interface AppNavItem {
  label: string;
  icon: string;
  route: string;
  permission?: string | null;
  anyPermissions?: string[];
  externalLink?: string | null;
}

export const menuItems: AppNavItem[] = [
  {
    label: 'Dashboard',
    icon: 'dashboard',
    route: '/m/dashboard',
  },
  {
    label: 'Collect',
    icon: 'collect',
    route: '/m/collect',
    anyPermissions: [PermissionsEnum.LoanView, PermissionsEnum.TransactionView],
  },
  {
    label: 'Reports & Analysis',
    icon: 'report',
    route: '/m/report&analysis',
    anyPermissions: [PermissionsEnum.LoanView],
  },
  {
    label: 'Billings & Settlement',
    icon: 'billings',
    route: '/m/billings&settlement',
    permission: PermissionsEnum.BillingView,
  },
  {
    label: 'Mandates & Tokens',
    icon: 'mandates',
    route: '/m/mandates&tokens',
    permission: PermissionsEnum.LoanView,
  },
  {
    label: 'Administration',
    icon: 'administration',
    route: '/m/administration',
    // anyPermissions: [
    //   PermissionsEnum.OrganisationView,
    //   PermissionsEnum.RolesView,
    //   PermissionsEnum.UsersView,
    //   PermissionsEnum.GroupView,
    //   PermissionsEnum.WebhooksView,
    // ],
  },
];

export const snackBarPosition = {
  horizontalPosition: 'right',
  verticalPosition: 'top',
  duration: 3000,
};

export const administrationMenuItems: AppNavItem[] = [
  {
    label: 'Organisations',
    icon: 'organisation',
    route: '/m/administration/organisations',
    externalLink: null,
    permission: PermissionsEnum.OrganisationView,
  },
  {
    label: 'Roles',
    icon: 'role',
    route: '/m/administration/roles',
    externalLink: null,
    permission: PermissionsEnum.RolesView,
  },
  {
    label: 'Users',
    icon: 'user',
    route: '/m/administration/users',
    externalLink: null,
    permission: PermissionsEnum.UsersView,
  },
  {
    label: 'Groups',
    icon: 'group',
    route: '/m/administration/groups',
    externalLink: null,
    permission: PermissionsEnum.GroupView,
  },
  {
    label: 'Audit Logs',
    icon: 'audit-logs',
    route: '/m/administration/audit-logs',
    externalLink: null,
    permission: null,
  },
  {
    label: 'Webhooks',
    icon: 'webhook',
    route: '/m/administration/webhooks',
    externalLink: null,
    // Webhooks permission check disabled: tab visible to all users
    // permission: PermissionsEnum.WebhooksView,
    permission: null,
  },
];

export const collectMenuItems: AppNavItem[] = [
  {
    label: 'Loans',
    icon: 'loan',
    route: '/m/collect/loans',
    permission: PermissionsEnum.LoanView,
  },
  {
    label: 'Customers',
    icon: 'customer',
    route: '/m/collect/customers',
    permission: PermissionsEnum.LoanView,
  },
  {
    label: 'Transactions',
    icon: 'transaction',
    route: '/m/collect/transactions',
    permission: PermissionsEnum.TransactionView,
  },
  {
    label: 'Proof of Payment',
    icon: 'proof-of-payment',
    route: '/m/collect/proof-of-payment',
    permission: PermissionsEnum.LoanView,
  },
  {
    label: 'Due Payments',
    icon: 'due-payments',
    route: '/m/collect/due-payments',
    permission: PermissionsEnum.LoanView,
  },
];

export const billingsSettlementMenuItems: AppNavItem[] = [
  {
    label: 'Billings',
    icon: 'billings',
    route: '/m/billings&settlement/billings',
    permission: PermissionsEnum.BillingView,
  },
  {
    label: 'Settlement',
    icon: 'settlement',
    route: '/m/billings&settlement/settlement',
    permission: PermissionsEnum.BillingView,
  },
];

export const states = [
  { value: 'Abia', name: 'Abia' },
  { value: 'Adamawa', name: 'Adamawa' },
  { value: 'Akwa Ibom', name: 'Akwa Ibom' },
  { value: 'Anambra', name: 'Anambra' },
  { value: 'Abuja', name: 'Abuja' },
  { value: 'Bauchi', name: 'Bauchi' },
  { value: 'Bayelsa', name: 'Bayelsa' },
  { value: 'Benue', name: 'Benue' },
  { value: 'Borno', name: 'Borno' },
  { value: 'Cross River', name: 'Cross River' },
  { value: 'Delta', name: 'Delta' },
  { value: 'Ebonyi', name: 'Ebonyi' },
  { value: 'Edo', name: 'Edo' },
  { value: 'Ekiti', name: 'Ekiti' },
  { value: 'Enugu', name: 'Enugu' },
  { value: 'Gombe', name: 'Gombe' },
  { value: 'Imo', name: 'Imo' },
  { value: 'Jigawa', name: 'Jigawa' },
  { value: 'Kaduna', name: 'Kaduna' },
  { value: 'Kano', name: 'Kano' },
  { value: 'Katsina', name: 'Katsina' },
  { value: 'Kebbi', name: 'Kebbi' },
  { value: 'Kogi', name: 'Kogi' },
  { value: 'Kwara', name: 'Kwara' },
  { value: 'Lagos', name: 'Lagos' },
  { value: 'Nassarawa', name: 'Nasarawa' },
  { value: 'Niger', name: 'Niger' },
  { value: 'Ogun', name: 'Ogun' },
  { value: 'Ondo', name: 'Ondo' },
  { value: 'Osun', name: 'Osun' },
  { value: 'Oyo', name: 'Oyo' },
  { value: 'Plateau', name: 'Plateau' },
  { value: 'Rivers', name: 'Rivers' },
  { value: 'Sokoto', name: 'Sokoto' },
  { value: 'Taraba', name: 'Taraba' },
  { value: 'Yobe', name: 'Yobe' },
  { value: 'Zamfara', name: 'Zamfara' },
];

export const supportedBanks = [
  'GUARANTY TRUST BANK PLC',
  'ACCESS BANK PLC',
  'STANDARD CHARTERED BANK PLC',
  'STANBIC IBTC BANK PLC',
  'FIRST BANK OF NIGERIA PLC',
  'FIRST CITY MONUMENT BANK PLC',
  'ZENITH INTERNATIONAL BANK PLC',
  'FIDELITY BANK PLC',
  'United Bank for Africa Plc',
  'UNION BANK OF NIGERIA PLC',
  'WEMA BANK PLC',
  'STERLING BANK PLC',
  'PROVIDUS',
  'ECOBANK NIGERIA PLC',
  'UNITY BANK PLC',
  'JAIZ BANK',
  'KEYSTONE BANK PLC',
  'POLARIS BANK',
  'Globus Bank',
  'SUNTRUST',
  'TAJ BANK',
  'TITAN TRUST BANK',
];

export const collateralCategories = [
  {
    name: 'Tangible Assets',
    value: 'TANGIBLE_ASSETS',
    subcategories: [
      {
        name: 'Real Estate',
        value: 'REAL_ESTATE',
        types: [
          { name: 'House (Residential)', value: 'HOUSE_RESIDENTIAL' },
          { name: 'House (Commercial)', value: 'HOUSE_COMMERCIAL' },
          { name: 'Land', value: 'LAND' },
          { name: 'Other', value: 'REAL_ESTATE_OTHER' },
        ],
      },
      {
        name: 'Vehicle',
        value: 'VEHICLE',
        types: [
          { name: 'Saloon Car', value: 'SALOON_CAR' },
          { name: 'SUV', value: 'SUV' },
          { name: 'Truck', value: 'TRUCK' },
          { name: 'Boat', value: 'BOAT' },
          { name: 'Aeroplane', value: 'AEROPLANE' },
          { name: 'Other', value: 'VEHICLE_OTHER' },
        ],
      },
      {
        name: 'Equipment',
        value: 'EQUIPMENT',
        types: [
          { name: 'Machinery', value: 'MACHINERY' },
          { name: 'Other', value: 'EQUIPMENT_OTHER' },
        ],
      },
      {
        name: 'Inventory',
        value: 'INVENTORY',
        types: [
          { name: 'Raw Material', value: 'RAW_MATERIAL' },
          { name: 'Finished Good', value: 'FINISHED_GOOD' },
          { name: 'Semi-Finished Good', value: 'SEMI_FINISHED_GOOD' },
        ],
      },
      {
        name: 'Personal Assets',
        value: 'PERSONAL_ASSETS',
        types: [
          { name: 'Jewelry', value: 'JEWELRY' },
          { name: 'Artwork', value: 'ARTWORK' },
          { name: 'Other', value: 'PERSONAL_ASSETS_OTHER' },
        ],
      },
    ],
  },
  {
    name: 'Financial Assets',
    value: 'FINANCIAL_ASSETS',
    subcategories: [
      {
        name: 'Cash',
        value: 'CASH',
        types: [
          { name: 'Savings account', value: 'SAVINGS_ACCOUNT' },
          { name: 'Cash deposit', value: 'CASH_DEPOSIT' },
        ],
      },
      {
        name: 'Investments',
        value: 'INVESTMENTS',
        types: [
          { name: 'Stocks', value: 'STOCKS' },
          { name: 'Bonds', value: 'BONDS' },
          { name: 'Fixed deposits', value: 'FIXED_DEPOSITS' },
          { name: 'Crypto', value: 'CRYPTO' },
          { name: 'Other', value: 'OTHER' },
        ],
      },
      {
        name: 'Account receivable',
        value: 'ACCOUNT_RECEIVABLE',
        types: [
          { name: 'Unpaid invoice', value: 'UNPAID_INVOICE' },
          { name: 'Unpaid dept', value: 'UNPAID_DEPT' },
          { name: 'Approved contract', value: 'APPROVED_CONTRACT' },
          { name: 'Other', value: 'OTHER' },
        ],
      },
    ],
  },
  {
    name: 'Other Assets',
    value: 'OTHER_ASSETS',
    types: [
      { name: 'Blanket lien', value: 'BLANKET_LIEN' },
      { name: 'Collateral mortgage', value: 'COLLATERAL_MORTGAGE' },
      { name: 'Debentures', value: 'DEBENTURES' },
    ],
  },
];
